import { useEffect, useRef, useState } from 'react';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Item from '../../../../components/Lists/Item';
import { NavBar } from '../../../../components/NavBar/NavBar';
import { SortingButton } from '../../../../components/Sorting/SortingButton';
import { SortingHeader } from '../../../../components/Sorting/SortingHeader';
import { SortingProvider } from '../../../../contexts/SortingContext';
import './VendorAwb.scss';
import Input from '../../../../components/Inputs/Input';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { createAWB, fetchDetails, getOrderInfo, nextPage, saveOrderInfo, selectAwbEditing, selectAwbLoading, selectAwbOpenStatus, selectAwbPage, selectAwbTotalPages, selectIdsSelection, selectItemsSelection, selectOrderByAwb, selectOrderItems, selectSearchAwb, selectSendInfo, toggleEdit, toggleOpen, toggleSelect, updateOrderBy, updateOrderItem, updateSearch, updateSendInfo } from '../../../../redux/features/VendorModule/VendorAwb/VendorAwbSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Bold, Hlght } from '../VendorApproval/VendorApproval';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { DropdownsProvider } from '../../../../contexts/DropdownsContext';
import Filters from '../../../../components/Filters/Filters';
import { FiltersManager } from '../../../../components/FiltersManager/FiltersManager';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import { DeleteAWB } from './DeleteAWB';
import { order } from '@mui/system';
import useDebounce from '../../../../hooks/useDebounce';

let mockDetails = [
    {
        "id": 0,
        "orderType": "PO",
        "orderNumber": "256489312",
        "lineNumer": 1,
        "partNumber": "111-222-333",
        "quantity": "1 EA",
        "description": "--",
        "requestedBy": "Spirit Airlines Inc.",
        "location": "MIA",
        "site": "Warehouse 01",
        "daysSince": 44,
        "AWB": "",
        "serialNumber": "",
        "vendorLot": ""
    },
    {
        "id": 1,
        "orderType": "PO",
        "orderNumber": "256489312",
        "lineNumer": 2,
        "partNumber": "444-555-666",
        "quantity": "1 EA",
        "description": "Hydraulic Pump",
        "requestedBy": "Spirit Airlines Inc.",
        "location": "MIA",
        "site": "Warehouse 01",
        "daysSince": 12,
        "AWB": "",
        "serialNumber": "",
        "vendorLot": ""
    },
    {
        "id": 2,
        "orderType": "LO",
        "orderNumber": "789654123",
        "lineNumer": 1,
        "partNumber": "777-888-999",
        "quantity": "1 EA",
        "description": "Landing Gear",
        "requestedBy": "Spirit Airlines Inc.",
        "location": "DFW",
        "site": "Warehouse 02",
        "daysSince": 30,
        "AWB": "",
        "serialNumber": "",
        "vendorLot": ""
    },
    {
        "id": 13,
        "orderType": "PO",
        "orderNumber": "753159486",
        "lineNumer": 1,
        "partNumber": "CON-101-LUB",
        "quantity": "10 L",
        "description": "Synthetic Lubricant",
        "requestedBy": "Spirit Airlines Inc.",
        "location": "MIA",
        "site": "Warehouse 01",
        "daysSince": 6,
        "AWB": "",
        "serialNumber": "",
        "vendorLot": ""
    },
    {
        "id": 14,
        "orderType": "PO",
        "orderNumber": "159486753",
        "lineNumer": 1,
        "partNumber": "CON-102-CLN",
        "quantity": "20 L",
        "description": "Aircraft Cleaning Solution",
        "requestedBy": "Spirit Airlines Inc.",
        "location": "ORD",
        "site": "Warehouse 04",
        "daysSince": 14,
        "AWB": "",
        "serialNumber": "",
        "vendorLot": ""
    },
    {
        "id": 15,
        "orderType": "PO",
        "orderNumber": "486753159",
        "lineNumer": 1,
        "partNumber": "CON-103-SEA",
        "quantity": "5 KG",
        "description": "Fuel Tank Sealant",
        "requestedBy": "Spirit Airlines Inc.",
        "location": "LAX",
        "site": "Warehouse 03",
        "daysSince": 9,
        "AWB": "",
        "serialNumber": "",
        "vendorLot": ""
    }
    ,
    //   {
    //     "id": 6,
    //     "orderType": "PO",
    //     "orderNumber": "147258369",
    //     "lineNumer": 2,
    //     "partNumber": "741-852-963",
    //     "quantity": "2 EA",
    //     "description": "Wing Panel",
    //     "requestedBy": "Spirit Airlines Inc.",
    //     "location": "ATL",
    //     "site": "Warehouse 05",
    //     "daysSince": 25,
    //     "AWB": "",
    //     "serialNumber": "",
    //     "vendorLot": ""
    //   },
    //   {
    //     "id": 7,
    //     "orderType": "LO",
    //     "orderNumber": "369258147",
    //     "lineNumer": 1,
    //     "partNumber": "159-753-486",
    //     "quantity": "6 EA",
    //     "description": "Cabin Light",
    //     "requestedBy": "Spirit Airlines Inc.",
    //     "location": "JFK",
    //     "site": "Warehouse 06",
    //     "daysSince": 3,
    //     "AWB": "",
    //     "serialNumber": "",
    //     "vendorLot": ""
    //   },
    //   {
    //     "id": 8,
    //     "orderType": "RO",
    //     "orderNumber": "321456987",
    //     "lineNumer": 2,
    //     "partNumber": "258-369-147",
    //     "quantity": "1 EA",
    //     "description": "Navigation Display",
    //     "requestedBy": "Spirit Airlines Inc.",
    //     "location": "LAX",
    //     "site": "Warehouse 03",
    //     "daysSince": 7,
    //     "AWB": "",
    //     "serialNumber": "",
    //     "vendorLot": ""
    //   },
    //   {
    //     "id": 9,
    //     "orderType": "SO",
    //     "orderNumber": "654987321",
    //     "lineNumer": 2,
    //     "partNumber": "456-789-123",
    //     "quantity": "3 EA",
    //     "description": "Engine Mount",
    //     "requestedBy": "Spirit Airlines Inc.",
    //     "location": "ORD",
    //     "site": "Warehouse 04",
    //     "daysSince": 18,
    //     "AWB": "",
    //     "serialNumber": "",
    //     "vendorLot": ""
    //   }
];

const mockData = [
    { id: 0, orderType: "PO", status: "STV", orderNumber: "202508001", location: "MIA", site: "Warehouse 01", dateRequired: "2025-07-23", priority: "Medium", requestedBy: "Spirit Airlines", supplyChain: "9876542123", created: "2025-07-01", daysSince: "44", totalCost: "$1,500.00 USD" },

    {
        id: 1,
        orderType: "RO",
        status: "STV",
        orderNumber: "202508002",
        location: "LAX",
        site: "Receiving Dock A",
        dateRequired: "2025-07-25",
        priority: "High",
        requestedBy: "Delta Cargo",
        supplyChain: "1234567890",
        created: "2025-07-02",
        daysSince: "43",
        totalCost: "$2,750.00 USD"
    },
    {
        id: 2,
        orderType: "LO",
        status: "STV",
        orderNumber: "202508003",
        location: "JFK",
        site: "Logistics Hub 3",
        dateRequired: "2025-07-26",
        priority: "Low",
        requestedBy: "American Airlines",
        supplyChain: "4567891230",
        created: "2025-07-03",
        daysSince: "42",
        totalCost: "$980.00 USD"
    },
    {
        id: 3,
        orderType: "SO",
        status: "STV",
        orderNumber: "202508004",
        location: "ORD",
        site: "Outbound Bay 2",
        dateRequired: "2025-07-27",
        priority: "Medium",
        requestedBy: "United Express",
        supplyChain: "7890123456",
        created: "2025-07-04",
        daysSince: "41",
        totalCost: "$1,200.00 USD"
    },
    {
        id: 4,
        orderType: "PO",
        status: "STV",
        orderNumber: "202508005",
        location: "ATL",
        site: "Warehouse 02",
        dateRequired: "2025-07-28",
        priority: "High",
        requestedBy: "JetBlue Logistics",
        supplyChain: "3216549870",
        created: "2025-07-05",
        daysSince: "40",
        totalCost: "$3,100.00 USD"
    },
    {
        id: 5,
        orderType: "RO",
        status: "STV",
        orderNumber: "202508006",
        location: "SEA",
        site: "Receiving Dock B",
        dateRequired: "2025-07-29",
        priority: "Medium",
        requestedBy: "Alaska Air",
        supplyChain: "6543217890",
        created: "2025-07-06",
        daysSince: "39",
        totalCost: "$1,850.00 USD"
    }

]

const Line = (item, property, onSelectChange) => {
    const [checked, setChecked] = useState(false);
    return (
        <div className='line-value'>
            {/* <Checkbox outlined checked={checked} onChange={v => { setChecked(v); onSelectChange?.(v) }} /> */}
            {item[property] || "--"}
        </div>)
}

const saveButtons = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];


const AwbLink = (item, key, onSaveSuccess) => {
    let awb = item[key];
    return (
        Boolean(awb) ?
            <DialogTrigger dialogContent={{ component: DeleteAWB, props: { AWB: awb, onSaveSuccess } }}>
                <div className='highlight awb'>
                    {/* <i className={orderTypeIcon[item["orderType"]]}></i> */}

                    <span>{awb || "--"}</span>
                </div>
            </DialogTrigger> :
            <span>{awb || "--"}</span>
    )

}

const FloatingButton = ({ shown, cancelClick, send }) => {
    const [awb, setAwb] = useState("");
    const [account, setAccount] = useState("");
    const [vendor, setVendor] = useState("");
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        setAwb("");
        setAccount("");
        setVendor("");
        setRemarks("");
    }, [shown]);

    return (
        <div className={`floating-panel ${shown ? 'active' : ''}`}>
            <b>AWB Number</b>
            <Input value={awb} onChange={e => setAwb(e.target.value)} />
            <Input value={vendor} onChange={e => setVendor(e.target.value)} label="Ship Via Vendor" />
            <Input value={account} onChange={e => setAccount(e.target.value)} label="Ship Via Account" />
            <Input value={remarks} onChange={e => setRemarks(e.target.value)} label="Ship Via Remarks" />
            <button className='filled greenButton' onClick={() => send(awb, vendor, account, remarks)}>Create AWB</button>
            <button className='filled danger' onClick={cancelClick}>Cancel</button>

        </div>)
}

const OpenContainer = ({tempId, anvoId}) => {
    const openStatus = useSelector(selectAwbOpenStatus);
    let orderOpen = openStatus[tempId];
    const dispatch = useDispatch();

    useEffect(()=>{
        if(orderOpen === true && (typeof(anvoId) === 'number')) {
            dispatch(getOrderInfo({anvoId, tempId}))
        }
    },[orderOpen])

    return (<></>)
}

const VendorAwb = ({ }) => {
    const [c, setC] = useState(0);
    // const [selection, setSelection] = useState({});

    const sendInfo = useSelector(selectSendInfo);
    const { successMsg } = useSnackBar();



    const orderItems = useSelector(selectOrderItems);
    const selection = useSelector(selectItemsSelection);
    const selectionIds = useSelector(selectIdsSelection);
    const loading = useSelector(selectAwbLoading);
    const editing = useSelector(selectAwbEditing);
    const select = (tempId, itemId, v) => {
        dispatch(toggleSelect({ tempId, itemId, v }))

        // setSelection(prev => ({ ...prev, [idx]: v }));
        // setC(prev => v ? prev + 1 : prev - 1);
    }
    // const { successMsg } = useSnackBar();
    const dispatch = useDispatch();

    useEffect(() => {
        setC(Object.values(selection).filter(Boolean).length)
    }, [selection]);

    const search = useSelector(selectSearchAwb);
    const orderBy = useSelector(selectOrderByAwb);
    const page = useSelector(selectAwbPage);
    const totalPages = useSelector(selectAwbTotalPages);

    useEffect(() => {
        dispatch(fetchDetails({ companyId: parseInt(localStorage.getItem("u_company_id")), search: search, page: page, orderBy: orderBy }));
    }, [search, page, orderBy])

    const send = (awb, vendor, account, remarks) => {
        // console.warn("create awb call", awb, vendor, account, remarks);
        // dispatch(createAWB({ awb, orderDetailIds: Object.keys(selectionIds).filter(k => selectionIds[k] === true), orders:Object.keys(selection).filter(k => selection[k] === true).map(tempId => sendInfo[tempId]), shipViaVendorId: vendor, shipViaAccountId: account, shipViaRemarks:remarks }));
        dispatch(createAWB({ awb, orderDetailObjs: Object.keys(selection).filter(k => selection[k] === true)
            .map(detailTempId => {
                let orderDetail = orderItems.find(orderDetail => orderDetail.tempId === detailTempId);
                return {vendorOrderDetailId: orderDetail.id, awbVendorOrderId: orderDetail.anvoId, tempId: orderDetail.tempId};
               }
            ), ordersSendInfo: Object.keys(selection).filter(k => selection[k] === true).map(tempId => sendInfo[tempId]), shipViaVendorId: vendor, shipViaAccountId: account, shipViaRemarks: remarks }));

        // console.warn(awb);
        // setSent(prev => ({
        //     ...Object.fromEntries(
        //         Object.entries(selection).filter(([_, value]) => value)
        //     ), ...Object.fromEntries(
        //         Object.entries(prev).filter(([_, value]) => value)
        //     )
        // }));
        // setOrders(prev => prev.map((order, j) => ((selection[j]) ? { ...order, AWB: awb || "" } : order)))
        // setSelection({});
        // setC(0);
        // successMsg(`AWB ${awb} created successfully`)

    }

    const [filtersOpen, setFiltersOpen] = useState(false);
    const onFiltersChange = () => { };

    const saveOrderInfoCall = (tempId) => {
        dispatch(saveOrderInfo({ orderInfo: sendInfo[tempId], tempId })).then(action => {
            if (action.payload) {
                successMsg("Order information saved");
            }
        })
    }

    const onSaveSuccess = (awb, idx) => {
        dispatch(updateOrderItem({ idx, name: "awb_number", value: awb }))
    }

    const requestNextPage = () => {
        dispatch(nextPage());
    }

    const handleScroll = (event) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        if (scrollHeight - (scrollTop + 3) <= clientHeight) {
            if (!loading) {
                if (totalPages > (page)) requestNextPage();
            }
        }
    };

    const toggleEdition = (tempId, value) => {
        dispatch(toggleEdit({tempId, value}));

    }

    const openStatus = useSelector(selectAwbOpenStatus);

    return (
        <SortingContainer>
            <div className='vendor-awb-component'>
                <NavBar searchInputProps={{
                    onTextChange: (e) => dispatch(updateSearch({ search: e })),
                }}
                    dataBreadCrumbs="/vendor/awb" moduleId={13} isLocalSearch searchActions={<><SortingButton></SortingButton>
                        {/* <FiltersManager onButtonClick={() => setFiltersOpen((prev) => !prev)} /> */}
                    </>} />
                <div className='v-app-content'>
                    <Filters
                        extOpen={filtersOpen}
                        openChange={(value) => setFiltersOpen(value)}
                        onApplyFilters={onFiltersChange}
                        hideToggle
                        dropdownIds={[1, 2, 3]}
                        hideATA
                    />
                    {/* <div className='filters'>
                        <Dropdowns />
                    </div> */}
                    <SortingHeader><b></b></SortingHeader>
                   
                    {/* {JSON.stringify(orderItems)} */}
                    <div className='details-list' onScroll={handleScroll}>

                        {orderItems.map((ordr, idx) =>
                            <>
                            {/* <input/> */}
                            <OpenContainer tempId={ordr.tempId} anvoId={ordr.anvoId}/>
                            <Expandable2 onOpenChange={value => dispatch(toggleOpen({tempId: ordr.tempId, value}))}  summary={<>
                                {/* {JSON.stringify(ordr.status)} */}
                                <Item className={(selection[ordr.tempId]) ? 'selected-item' : ((ordr.status === "Shipped" || ordr.status === "shipped") ? "selected-item sent-item" : "")} startCols={
                                    (ordr.status === "Shipped" || ordr.status === "shipped") ? <b className='sent-indicator'>SENT</b> :
                                        <Checkbox outlined checked={selection[ordr.tempId] === true} onChange={
                                            (v, e) => { if (openStatus[ordr.tempId]){e.stopPropagation(); e?.preventDefault?.();} select(ordr.tempId, ordr.id, v)}
                                        } />

                                } valuePlaceholder="--" orderedProperties={["orderType", "parentId", "line", "partNumber", "qtyab", "partName", "requestedBy", "location", "daysSince", "awb_number", "serialNumber", "vendorLot"]} renderProperty={{ "orderType": (item, keyN) => Line(item, keyN, (v) => select(idx, v)), "daysSince": Hlght, "qtyab": Bold, "awb_number": (item, key) => AwbLink(item, key, (awb) => onSaveSuccess(awb, idx)) }} ignoreProperties={["id", "status"]} lightFont hideLabels key={ordr} item={ordr}>
                                    {/* <Item renderProperty={{ "orderType": OrderType, "daysSince": Hlght }} ignoreProperties={["id", "status"]} lightFont hideLabels key={ordr} item={ordr}> */}

                                </Item></>}>
                                {(ordr.status === "Vendor Approved" || ordr.status === "Partially Shipped" || ordr.status === "package_in_take") && <div className="general-info">
                                    <div className='left'>
                                        <b>General Information</b>
                                        {ordr.category === "Serialized" && <div className='input-container'>
                                            <b>SN</b>
                                            <InputWrapper disabled={!(editing[ordr.tempId] === true)} label="" defaultValue={sendInfo[ordr.tempId].serialNumber} onChange={(eValue) => dispatch(updateSendInfo({ tempId: ordr.tempId, name: "serialNumber", value: eValue }))} />
                                        </div>}
                                        <div className='input-container'>
                                            <b>Vendor Lot</b>
                                            <InputWrapper disabled={!(editing[ordr.tempId] === true)} label="" defaultValue={sendInfo[ordr.tempId].vendorLot} onChange={(eValue) => dispatch(updateSendInfo({ tempId: ordr.tempId, name: "vendorLot", value: eValue }))} />
                                        </div>
                                        {ordr.category === "Serialized" ?
                                            <div className='input-container'>
                                                <b>QTY</b>
                                                <b>{ordr.qtyab}</b>

                                            </div>
                                            : <div className='input-container'>
                                                <b>QTY</b>
                                                <InputWrapper disabled={!(editing[ordr.tempId] === true)} label="" defaultValue={sendInfo[ordr.tempId].quantity || ""} onChange={(eValue) => dispatch(updateSendInfo({ tempId: ordr.tempId, name: "quantity", value: parseInt(eValue) }))} />

                                                <b>{ordr.abreviation}</b>

                                            </div>}
                                    </div>
                                    <div className='right'>
                                        {editing[ordr.tempId] === true ?
                                            <MultioptionButton buttons={saveButtons} buttonCallbacks={{ 'save': () => saveOrderInfoCall(ordr.tempId), 'save-continue': () => saveOrderInfoCall(ordr.tempId), 'cancel': () => { toggleEdition(ordr.tempId, false)} }}></MultioptionButton>
                                            :
                                            <button onClick={() => toggleEdition(ordr.tempId, true)} className='outlined iconTextButton small-size'>
                                                <i className='icon-edit'></i>
                                                <span>Edit</span>
                                            </button>
                                        }
                                    </div>
                                </div>}
                            </Expandable2>
                            </>
                            
                        )}
                    </div>
                </div>
                <FloatingButton send={send} shown={c > 0} >
                    {/* Options dropdown 1:   */}
                    {/* Options dropdown 2:   */}
                </FloatingButton>
            </div>
        </SortingContainer >

    )

}

const InputWrapper = ({defaultValue, onChange, ...props}) =>{
    const [localValue, setLocalValue] = useState(defaultValue);

    const debValue = useDebounce(localValue, 300);

    useEffect(()=>{
        onChange?.(localValue);
    },[localValue]);

    useEffect(()=>{
        setLocalValue(defaultValue);
    },[defaultValue])

    return (<Input value={localValue} onChange={(e)=>setLocalValue(e.target.value)}  {...props}/>);


}

const SortingContainer = ({ children }) => {
    const dispatch = useDispatch();



    return (
        <SortingProvider onOrderChange={(e) => dispatch(updateOrderBy({orderBy:e}))} properties={{
            "orderType": "Order Type",
            "parentId": "Order Number",
            "lineNumber": "LN",
            "partNumber": "PN",
            "quantity": "QTY",
            "description": "Description",
            "requestedBy": "Requested By",
            "location": "Location",
            "daysSince": "Days Since",
            "awb_number": "AWB",
            "serialNumber": "SN",
            "vendorLot": "Vendor Lot"
        }}>
            {/* <DropdownsProvider> */}
            {children}
            {/* </DropdownsProvider> */}
        </SortingProvider>
    )

}
export default VendorAwb;